export default __webpack_public_path__ + "static/adaptLogo-056827a8faf00c037033a2a2b7f7d5af.png";